import { CapacitorCalendar } from '@ebarooni/capacitor-calendar';
import { angularInjectorProvider } from 'Injector';
import { type ErrorLogService as ErrorLogServiceClass } from 'ErrorLogging';
import { type DeviceCalendarEvent } from './DeviceCalendar.types';

export async function addEventToDeviceCalendar(event: DeviceCalendarEvent): Promise<boolean> {
    try {
        await CapacitorCalendar.createEventWithPrompt({
            title: event.title,
            location: event.address,
            description: event.description,
            startDate: event.startDate.getTime(),
            // The plugin reads an all-day end date as the last day of the event, not the day after it.
            endDate: event.allDay ? event.endDate.getTime() - 1 : event.endDate.getTime(),
            isAllDay: !!event.allDay,
            url: event.url || undefined,
        });
        return true;
    } catch (error) {
        angularInjectorProvider
            .safeGet<typeof ErrorLogServiceClass>('ErrorLogService')
            ?.notify('Failed to add an event to the device calendar', error, {
                level: 'error',
                event_title: event.title,
            });
        return false;
    }
}
